import React, {createRef} from "react"

type ClickOutsideProps = {
  do: Function
}

class ClickOutside extends React.Component<ClickOutsideProps> {
  private node = createRef<HTMLDivElement>()

  componentDidMount() {
    document.addEventListener('mousedown', this.handleClick, false)
  }

  componentWillUnmount() {
    document.removeEventListener('mousedown', this.handleClick, false)
  }

  handleClick = (event: MouseEvent) => {
    if (this.node.current && this.node.current.contains(event.target as Node)) {
      return
    }

    this.props.do && this.props.do()
  }

  render() {
    return (
      <div ref={this.node}>
        {this.props.children}
      </div>
    )
  }
}


export default ClickOutside
